<template>
  <div id="app-div" style="overflow-y: hidden">
    <div class="top">
      <div class="search_icon">
        <span style="margin-left: 10px">
          <img src="../../../assets/u3220.png" class="icon_img" />
          筛选查询
        </span>
      </div>
      <div class="query_div">
        <a-row>
          <a-col :span="8">
            <label>年份：</label>
            <a-input
              placeholder="请输入"
              v-model="yearLeft"
              style="width: 100px"
            />
            <label class="padding: 10px">-</label>
            <a-input
              placeholder="请输入"
              v-model="yearRight"
              style="width: 100px"
            />
          </a-col>
          <a-button type="primary" class="query_btn" @click="query"
            >查询</a-button
          >
        </a-row>
      </div>
    </div>
    <div class="middle">
      <div style="float: left; margin-left: 10px">
        <img src="../../../assets/u3227.png" class="icon_img" />
        <span>&nbsp;数据列表</span>
      </div>
    </div>
    <div class="bottom" id="bottom">
      <div class="table_box">
        <a-table
          :pagination="false"
          :rowSelection="rowSelection"
          :columns="columns"
          :dataSource="data"
          :rowKey="(record) => record.year"
          size="small"
          :scroll="{ y: data.length < 8 ? false : table_height }"
          bordered
        ></a-table>
      </div>
      <div id="components-pagination-demo-mini">
        <a-pagination
          :total="total"
          :showTotal="(total) => `共 ${total} 条`"
          showSizeChanger
          showQuickJumper
          :pageSizeOptions="pageSizeOptions"
          :defaultPageSize="limit"
          @showSizeChange="onShowSizeChange"
          @change="pageChange"
        />
      </div>
      <a-select
        defaultValue="0"
        class="batch_operation"
        @change="operateChange"
        v-model="operateCode"
      >
        <a-select-option value="0">批量操作</a-select-option>
        <a-select-option value="1">批量导出</a-select-option>
      </a-select>
    </div>
  </div>
</template>

<script>
const columns = [
  {
    title: "年份",
    dataIndex: "year",
    align: "center",
    sorter: (a, b) => a.year - b.year,
  },
  {
    title: "投稿数量",
    dataIndex: "contribute",
    align: "center",
    sorter: (a, b) => a.contribute - b.contribute,
  },
  {
    title: "录用数量",
    dataIndex: "hire",
    align: "center",
    sorter: (a, b) => a.hire - b.hire,
  },
  {
    title: "发表数量",
    dataIndex: "publish",
    align: "center",
    sorter: (a, b) => a.publish - b.publish,
  },
  {
    title: "退稿数量",
    dataIndex: "return",
    align: "center",
    sorter: (a, b) => a.return - b.return,
  },
  {
    title: "处理中数量",
    dataIndex: "going",
    align: "center",
    sorter: (a, b) => a.going - b.going,
  },
  {
    title: "基金项目",
    dataIndex: "fund",
    align: "center",
  },
  {
    title: "科研课题",
    dataIndex: "science",
    align: "center",
  },
];

const data = [];
import qs from "qs";

export default {
  data() {
    return {
      yearLeft: "",
      yearRight: "",
      data,
      columns,
      selectedRowKeys: [],
      operateCode: "0",
      page: 1,
      limit: 20,
      total: 0,
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      table_height: 0,
      value: 1,
      sort: "1",
      sortField: "total",
      sortType: "desc",
    };
  },
  name: "journalSet",
  computed: {
    //选择、全选组件
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        columnWidth: 35,
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,
        onSelection: this.onSelection,
      };
    },
  },
  created() {
    this.query();
  },
  mounted() {
    //设置bottom高度
    var height = document.body.clientHeight;
    var bottom_height = height - 230;
    var bottom = document.getElementById("bottom");
    bottom.style.height = bottom_height + "px";
    this.table_height = bottom_height - 100;
  },
  methods: {
    sortChange() {
      if (this.sort == 1) {
        this.sortField = "total";
        this.sortType = "desc";
      } else if (this.sort == 2) {
        this.sortField = "total";
        this.sortType = "";
      } else if (this.sort == 3) {
        this.sortField = "create_time";
        this.sortType = "desc";
      } else if (this.sort == 4) {
        this.sortField = "create_time";
        this.sortType = "";
      }
      this.query();
    },
    operateChange() {
      if (this.operateCode != "0") {
        var itemLegth = this.selectedRowKeys.length;
        if (itemLegth == 0) {
          this.utils.messageInfo(this, "error", "最少选择一条数据！");
          return;
        }
      }
      if (this.operateCode == "1") {
        var jsonData = [];
        for (var i = 0; i < this.data.length; i++) {
          for (var j = 0; j < this.selectedRowKeys.length; j++) {
            if (this.data[i].year == this.selectedRowKeys[j]) {
              var json = {
                year: this.data[i].year,
                contribute: this.data[i].contribute,
                hire: this.data[i].hire,
                publish: this.data[i].publish,
                return: this.data[i].return,
                going: this.data[i].going,
                fund: this.data[i].fund,
                science: this.data[i].science,
              };
              jsonData.push(json);
            }
          }
        }
        exportData(jsonData);
      }
    },

    onShowSizeChange(current, pageSize) {
      this.page = current;
      this.limit = pageSize;
      this.query();
    },
    pageChange(pageNumber) {
      this.page = pageNumber;
      this.query();
    },
    //选择全选对勾
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    query() {
      this.axios
        .get("/statistical/periodical", {
          params: {
            yearLeft: this.yearLeft,
            yearRight: this.yearRight,
            sortField: this.sortField,
            sortType: this.sortType,
            page: this.page,
            limit: this.limit,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.total = res.data.count;
            this.data = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询稿件列表失败！");
          }
        });
    },
  },
};

function exportData(jsonData) {
  //列标题，逗号隔开，每一个逗号就是隔开一个单元格
  let str = `年份,投稿数量,录用数量,发表数量,退稿数量,处理中数量,基金项目,科研课题\n`;
  //增加\t为了不让表格显示科学计数法或者其他格式
  for (let i = 0; i < jsonData.length; i++) {
    for (let item in jsonData[i]) {
      str += `${jsonData[i][item] + "\t"},`;
    }
    str += "\n";
  }
  //encodeURIComponent解决中文乱码
  let uri = "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(str);
  //通过创建a标签实现
  let link = document.createElement("a");
  link.href = uri;
  //对下载的文件命名
  link.download = "期刊统计.csv";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
</script> 
<style>
@import "../../../assets/css/PageCss.css";
</style>
<style>
